module.exports = __webpack_public_path__ + "img/logo.6fcb5495.png";